/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_TitleInputs */

const en_render_audio_title = /** @type {(inputs: Render_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Rendering`)
};

const fr_render_audio_title = /** @type {(inputs: Render_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendu audio`)
};

const de_render_audio_title = /** @type {(inputs: Render_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio-Rendering`)
};

const it_render_audio_title = /** @type {(inputs: Render_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendering audio`)
};

const ru_render_audio_title = /** @type {(inputs: Render_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка звука`)
};

const es_render_audio_title = /** @type {(inputs: Render_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Representación de audio`)
};

const zh_cn2_render_audio_title = /** @type {(inputs: Render_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频渲染`)
};

const ja_render_audio_title = /** @type {(inputs: Render_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオレンダリング`)
};

const hi_render_audio_title = /** @type {(inputs: Render_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो रेंडरिंग`)
};

const pt_pt2_render_audio_title = /** @type {(inputs: Render_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renderização de áudio`)
};

/**
* | output |
* | --- |
* | "Audio Rendering" |
*
* @param {Render_Audio_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_title = /** @type {((inputs?: Render_Audio_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_render_audio_title(inputs)
	if (locale === "de") return de_render_audio_title(inputs)
	if (locale === "it") return it_render_audio_title(inputs)
	if (locale === "ru") return ru_render_audio_title(inputs)
	if (locale === "es") return es_render_audio_title(inputs)
	if (locale === "zh-CN") return zh_cn2_render_audio_title(inputs)
	if (locale === "ja") return ja_render_audio_title(inputs)
	if (locale === "hi") return hi_render_audio_title(inputs)
	if (locale === "pt-PT") return pt_pt2_render_audio_title(inputs)
	return en_render_audio_title(inputs)
});